/*
  //https://github.com/moment/moment/issues/5166

  import * as moment from "moment"; doesn't work for unit testing in jest.

  typeerror moment_1.default is not a function
*/

const moment = require("moment").default || require("moment");

export const getDatesInRange = (start: Date, end: Date): Array<Date> => {
  const dates: Array<Date> = [];

  const iterator = new Date(start);

  while (iterator <= end) {
    dates.push(new Date(iterator));

    iterator.setDate(iterator.getDate() + 1);
  }

  return dates;
};

export const addDaysToCurrentDate = (days: number): Date => {
  return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + days, 0, 0, 0, 0);
};

export const addDays = (date: Date, days: number): Date => {
  const newDate = new Date(Number(date));
  newDate.setDate(date.getDate() + days);

  return newDate;
};

export const isoStringToDate = (date: string): Date => {
  return new Date(Date.parse(date));
};

export const dateToIsoString = (date: Date): string => {
  return moment(date).toISOString();
};

export const viewDatePartsToDateUTC = (
  year: string | null,
  month: string | null,
  day: string | null,
  hours: string | null,
  minutes: string | null
) => {
  return new Date(
    Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      hours ? Number(hours) : 0,
      minutes ? Number(minutes) : 0,
      0,
      0
    )
  );
};

export const viewDatePartsToDate = (
  year: string | null,
  month: string | null,
  day: string | null,
  hours: string | null,
  minutes: string | null
) => {
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    hours ? Number(hours) : 0,
    minutes ? Number(minutes) : 0,
    0,
    0
  );
};

export const datePartsToIsoString = (
  year: string | null,
  month: string | null,
  day: string | null,
  hours: string | null = "00",
  minutes: string | null = "00",
  seconds: string | null = "00"
): string => {
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const getMillisecondsFromDateTimeString = (date: string): string => {
  const index = date.lastIndexOf(".") + 1;

  return date.slice(index, index + 5);
};

export const setDateLocale = (locale: string): void => {
  moment.locale(locale);
};

export const formatStringToDateString = (date: string, formatType: DateFormatEnum): string => {
  return moment(date).format(formatType);
};

export const formatStringToDate = (date: string, format: DateFormatEnum): Date => {
  return new Date(moment(date, format));
};

export const formatStringToUtcDate = (date: string): Date | null => {
  if (/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/.test(date)) {
    const [day, month, year] = date.split("-");
    return viewDatePartsToDateUTC(year, month, day, null, null);
  }

  return null;
};

export const isValidDate = (date: string, format: DateFormatEnum): boolean => {
  return moment(date, format).isValid();
};

export const formatDate = (date: Date, formatType: DateFormatEnum): string => {
  moment.locale("nl");
  if (formatType === DateFormatEnum.Default) {
    return moment(date).format();
  }
  return moment(date).format(formatType);
};

export enum DateFormatEnum {
  Default,
  DayOfMonth = "DD",
  Month = "MM",
  MonthNameAndYear = "MMMM YYYY",
  Year = "YYYY",
  IsoDate = "YYYY-MM-DD",
  Date = "DD-MM-YYYY",
  DateShortYear = "DD-MM-YY",
  DateAndTime = "DD-MM-YYYY HH:mm",
  DateAndTimeWithSeconds = "DD-MM-YYYY HH:mm:ss",
  DayAndDateAndTime = "dd DD-MM-YY HH:mm",
  DayAndDate = "dd DD-MM-YY",
  DayWrittenMonthYear = "LL",
  Time = "LT"
}

export const datePartsToString = (
  day?: string | null,
  month?: string | null,
  year?: string | null
): string => {
  return `${day && day.length === 1 ? "0" : ""}${day}-${
    month && month.length === 1 ? "0" : ""
  }${month}-${year}`;
};

export const numberDaysBetween = (dateA: Date, dateB: Date): number => {
  const calcDifference = Math.abs(dateA.getTime() - dateB.getTime());

  return calcDifference / (1000 * 60 * 60 * 24);
};

export const optionalDateToDateOrNull = (value: Date | null | undefined): Date | null => {
  return value !== null && value !== undefined ? value : null;
};
